import { DateRangePicker } from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate } from "@internationalized/date";

/**
 * Filter component for Stock Adjustment page
 */
const FilterData = ({ table, initialFilters }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    // Parse date range from pending values
    const dateRangeValue =
        pending.date_from && pending.date_to
            ? {
                  start: parseDate(pending.date_from),
                  end: parseDate(pending.date_to),
              }
            : null;

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Date Range */}
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRangeValue}
                onChange={(range) =>
                    setPending((prev) => ({
                        ...prev,
                        date_from: range?.start?.toString() || "",
                        date_to: range?.end?.toString() || "",
                    }))
                }
                variant="flat"
            />
        </FilterCard>
    );
};

export default FilterData;
